export default __webpack_public_path__ + "static/media/blue_mark_icon.12a0dde9.svg";